
import React from 'react';

export const AboutTab = () => {
  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h2 className="text-xl font-semibold mb-4">About Stewie Trader</h2>
      <div className="space-y-4">
        <div className="p-4 bg-gray-50 rounded-md">
          <p className="font-medium">Version</p>
          <p className="text-sm text-gray-500">v1.0.0</p>
        </div>
        
        <div className="p-4 bg-gray-50 rounded-md">
          <p className="font-medium">Build Date</p>
          <p className="text-sm text-gray-500">{new Date().toLocaleDateString()}</p>
        </div>
        
        <div className="p-4 bg-gray-50 rounded-md">
          <p className="font-medium">Support</p>
          <p className="text-sm text-gray-500">support@stewietrader.com</p>
        </div>
        
        <div className="p-4 bg-gray-50 rounded-md">
          <p className="font-medium">Documentation</p>
          <a 
            href="/docs" 
            className="text-sm text-blue-600 hover:underline"
          >
            View Documentation
          </a>
        </div>
        
        <div className="p-4 bg-gray-50 rounded-md">
          <p className="font-medium">Terms of Service</p>
          <a 
            href="#" 
            className="text-sm text-blue-600 hover:underline"
          >
            View Terms
          </a>
        </div>
        
        <div className="p-4 bg-gray-50 rounded-md">
          <p className="font-medium">Privacy Policy</p>
          <a 
            href="#" 
            className="text-sm text-blue-600 hover:underline"
          >
            View Privacy Policy
          </a>
        </div>
      </div>
    </div>
  );
};
